import React, { useRef } from "react";
import "./Home.css";
// import Button from "@mui/material/Button";
// import Navbar from "./Components/Navbar/Navbar";
// import Homepage from "./Screens/Homepage/Homepage";
import image from "../../Images/image.png";
import image1 from "../../Images/image (1).png";
import image2 from "../../Images/image (2).png";
import image3 from "../../Images/image (3).png";
import { useState } from "react";
import { CgQuote } from "react-icons/cg";
import { BsSoundwave } from "react-icons/bs";
import { TbMessageCircleFilled } from "react-icons/tb";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import scrollTrigger from "gsap/ScrollTrigger";
import SwiperCard from "../../Components/Swiper/SwiperCard";
import video1 from "../../Videos/video1.mp4";
import video2 from "../../Videos/video2.mp4";
import video3 from "../../Videos/video3.mp4";
import video4 from "../../Videos/video4.mp4";
//import heroSectionVideo from "../../Videos/heroSectionVideo.mp4";
//import heroSectionVideo from "../../Videos/heroSectionVideo1.mp4";
import videoImage1 from "../../Images/videoImage1.png";
import videoImage2 from "../../Images/videoImage2.png";
import videoImage3 from "../../Images/videoImage3.png";
import cosmetic_eyeliner from "../../Images/cosmetic_eyeliner.jpg";
import cosmetic_brush from "../../Images/cosmetic_brush.jpg";
import cosmetic_lipstick from "../../Images/cosmetic_lipstick.jpg";
import cosmetic_hair from "../../Images/cosmetic_hair.jpg";
import heroSectionImage from "../../Images/heroSectionImageFrame.png";

import { Outlet } from "react-router-dom";
import Button from "@mui/material/Button";
import Check from "@mui/icons-material/Check";
// import Submit from "@mui/icons-material/ArrowUpward";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import axios from "axios";
// import SkinToneDectector from "../../Components/SkinToneDectector/SkinToneDectector";
// import Collections from "../../Components/Collections/Collections";
// import Header from "../../Components/Header/Header";
// import RegisterAndLogin from "../../Components/RegisterAndLogin/RegisterAndLogin";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(scrollTrigger);

const Home = () => {
  const [next, setnext] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedItem, setselectedItem] = useState([]);
  const [todayLookSelectedItem, settodayLookSelectedItem] = useState([]);
  const [contrastLookSelectedItem, setcontrastLookSelectedItem] = useState([]);
  const [checkForSelectedItem, setcheckForSelectedItem] = useState(false);
  const [todayLook, settodayLook] = useState([
    { id: 1, name: "Party", status: false },
    { id: 2, name: "Family", status: false },
    { id: 3, name: "Beach", status: false },
    { id: 4, name: "Hills", status: false },
    { id: 5, name: "Office", status: false },
    { id: 6, name: "Wedding", status: false },
    { id: 7, name: "Western", status: false },
    { id: 8, name: "Northern", status: false },
  ]);

  const [contrastLook, setcontrastLook] = useState([
    { id: 1, name: "Vibrant", status: false },
    { id: 2, name: "natural", status: false },
    { id: 3, name: "complexion", status: false },
    { id: 4, name: "fair", status: false },
  ]);

  const [makeUpItems, setmakeUpItems] = useState([
    { id: 1, name: "lipstick", status: false },
    { id: 2, name: "eyeliner", status: false },
    { id: 3, name: "eyeshadow", status: false },
    { id: 4, name: "foundation", status: false },
    { id: 5, name: "powder blush", status: false },
    { id: 6, name: "cream blush", status: false },
  ]);

  const makeUpHeadings = [
    {
      heading: "Hey, How do you want to look today ?",
      sunHeading: "Select items you’d like to see in your makeup!",
    },
    {
      heading: "Hey, How do you want to look today1 ?",
      sunHeading: "Select items you’d like to see in your makeup1!",
    },
    {
      heading: "Hey, How do you want to look today2 ?",
      sunHeading: "Select items you’d like to see in your makeup2!",
    },
  ];

  // const [scrollingHandle, setScrollingHandle] = useState(0);
  const yoyoSpan1 = useRef(null);
  const yoyoSpan2 = useRef(null);
  const yoyoSpan3 = useRef(null);

  const imagesArr = [
    { image: image },
    { image: image1 },
    { image: image2 },
    { image: image3 },
  ];

  const handleTodayLookButton = (id, itemName) => {
    if (todayLookSelectedItem.includes(itemName)) {
      // Deselect if already selected
      settodayLookSelectedItem([]);
      setcheckForSelectedItem(false);
    } else {
      // Clear previous selection and add the new one
      settodayLookSelectedItem([itemName]);
      setcheckForSelectedItem(true);
    }

    // Update the todayLook state to ensure only one item is active
    const newData = todayLook.map((item) => ({
      ...item,
      status: item.id === id ? !item.status : false, // Select only the clicked item
    }));

    settodayLook(newData);
  };

  const handleContrastLook = (id, itemName) => {
    if (contrastLookSelectedItem.includes(itemName)) {
      // Deselect if already selected
      setcontrastLookSelectedItem([]);
      setcheckForSelectedItem(false);
    } else {
      // Clear previous selection and add the new one
      setcontrastLookSelectedItem([itemName]);
      setcheckForSelectedItem(true);
    }

    // Update the contrastLook state to ensure only one item is active
    const newData = contrastLook.map((item) => ({
      ...item,
      status: item.id === id ? !item.status : false, // Select only the clicked item
    }));

    setcontrastLook(newData);
  };

  const handleButton = (id, itemName) => {
    if (!selectedItem.includes(itemName)) {
      setselectedItem([...selectedItem, itemName]);
      setcheckForSelectedItem(true);
    }

    if (selectedItem.includes(itemName) && checkForSelectedItem) {
      const newData = selectedItem.filter((item) => item !== itemName);
      setselectedItem(newData);
    }

    const newData = makeUpItems.map((item) => {
      if (item.id === id) {
        if (item.status === true) {
          return {
            ...item,
            status: false,
          };
        } else {
          return {
            ...item,
            status: true,
          };
        }
      }
      return item;
    });

    setmakeUpItems(newData);
  };

  const hadleTodayLookData = () => {
    if (todayLookSelectedItem.length !== 0) {
      console.log(todayLookSelectedItem);
      setnext((prev) => prev + 1);
    } else console.log("Please select the items!");
  };
  const hadleContrastLookData = () => {
    if (contrastLookSelectedItem.length !== 0) {
      console.log(contrastLookSelectedItem);
      setnext((prev) => prev + 1);
    } else console.log("Please select the items!");
  };

  const hadleSubmitData = async () => {
    if (
      todayLookSelectedItem.length !== 0 &&
      contrastLookSelectedItem.length !== 0 &&
      selectedItem.length !== 0
    ) {
      const formData = {
        look: todayLookSelectedItem[0],
        style: contrastLookSelectedItem[0],
        subcategories: [...selectedItem],
      };
      console.log(formData);
      let url = `${process.env.REACT_APP_API_KEY}/`;

      try {
        const response = await axios.post(url, formData, {
          headers: { "Content-Type": "application/json" },
        });
        console.log(response);
      } catch (error) {
        console.log("error messgage : ", error);
      }
    } else console.log("Please select the items!");
  };
  const hadleMakeUpItems = () => {
    if (selectedItem.length !== 0) {
      console.log(selectedItem);

      // setnext(0);
      hadleSubmitData();
    } else console.log("Please select the items!");
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     // console.log("Scroll Position:", window.scrollY);

  //     if (window.scrollY > scrollingHandle && window.scrollY > 50) {
  //       // Scrolling down → Hide header
  //       gsap.to(".header", {
  //         opacity: 0,
  //         y: 0,
  //         duration: 0.5,
  //         ease: "power2.out",
  //       });
  //     } else if (window.scrollY < scrollingHandle) {
  //       // Scrolling up → Show header
  //       gsap.to(".header", {
  //         opacity: 1,
  //         y: 0,
  //         duration: 0.5,
  //         ease: "power2.out",
  //       });
  //     }

  //     setScrollingHandle(window.scrollY);
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [scrollingHandle]);

  useGSAP(() => {
    gsap.from(yoyoSpan1.current, {
      height: "17px",
      y: 7,
      yoyo: true,
      repeat: -1,
      duration: 0.8, // Increased duration for a smoother effect
      ease: "power1.inOut", // Added smooth easing
    });
    gsap.from(yoyoSpan2.current, {
      height: "17px",
      y: 7,
      yoyo: true,
      repeat: -1,
      duration: 0.8, // Increased duration for a smoother effect
      ease: "power1.inOut", // Added smooth easing
    });
    gsap.from(yoyoSpan3.current, {
      height: "17px",
      y: 7,
      yoyo: true,
      repeat: -1,
      duration: 0.8, // Increased duration for a smoother effect
      ease: "power1.inOut", // Added smooth easing
    });
    gsap.fromTo(
      ".mutlipleFrames .mutlipleFramesContainer video, .mutlipleFrames .mutlipleFramesContainer .videoImage1, .mutlipleFrames .mutlipleFramesContainer .videoImage2, .mutlipleFrames .mutlipleFramesContainer .videoImage3, .mutlipleFrames .mutlipleFramesContainer .videoImage4",
      {
        scale: 0.2, // Start slightly bigger than 0.1 for a smoother effect
        // opacity: 0, // Start with opacity 0
      },
      {
        scale: 1,
        // opacity: 1,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".mutlipleFrames .mutlipleFramesContainer",
          scroller: "body",
          start: "5% 80%",
          end: "top 0%",
          // scrub: 1,
          markers: false,
        },
      }
    );
  });

  return (
    <>
      <Outlet />
      <div className="heroSection">
        <img src={heroSectionImage} alt="heroSectionImage" />
        {/* <video loop muted autoPlay className="heroSection1">
          <source src={heroSectionVideo} type="video/mp4" />
        </video> */}
        <div className="left">
          <div className="makeupItemSelect">
            <h5>{makeUpHeadings[next].heading}</h5>
            <p>{makeUpHeadings[next].sunHeading}</p>

            <div className="buttonsContainer">
              {next === 0 &&
                todayLook.map((item, i) => {
                  return (
                    <Button
                      key={item.id}
                      className="selectableButton"
                      variant="contained"
                      endIcon={item.status && <Check />}
                      sx={{
                        width: "35%", // or your required width
                        backgroundColor: "white", // no background
                        color: "black", // or any preferred text color
                        fontFamily: "niavhFont",
                        borderRadius: "50px",
                        letterSpacing: "1px",
                        textTransform: "lowercase",
                        boxShadow: "none", // remove button shadow
                        "&:hover": {
                          backgroundColor: "white", // no bg on hover
                          color: "black", // retain same text color
                          boxShadow: "none",
                        },
                        "&:active": {
                          backgroundColor: "white", // no bg on click
                          boxShadow: "none",
                        },
                        "&:focus": {
                          backgroundColor: "white", // no focus bg
                          boxShadow: "none",
                        },
                      }}
                      onClick={() => handleTodayLookButton(item.id, item.name)}
                    >
                      {item.name}
                    </Button>
                  );
                })}
              {next === 1 &&
                contrastLook.map((item, i) => {
                  return (
                    <Button
                      key={item.id}
                      className="selectableButton"
                      variant="contained"
                      endIcon={item.status && <Check />}
                      sx={{
                        width: "35%", // or your required width
                        backgroundColor: "white", // no background
                        color: "black", // or any preferred text color
                        fontFamily: "niavhFont",
                        borderRadius: "50px",
                        letterSpacing: "1px",
                        textTransform: "lowercase",
                        boxShadow: "none", // remove button shadow
                        "&:hover": {
                          backgroundColor: "white", // no bg on hover
                          color: "black", // retain same text color
                          boxShadow: "none",
                        },
                        "&:active": {
                          backgroundColor: "white", // no bg on click
                          boxShadow: "none",
                        },
                        "&:focus": {
                          backgroundColor: "white", // no focus bg
                          boxShadow: "none",
                        },
                      }}
                      onClick={() => handleContrastLook(item.id, item.name)}
                    >
                      {item.name}
                    </Button>
                  );
                })}
              {next === 2 &&
                makeUpItems.map((item, i) => {
                  return (
                    <Button
                      key={item.id}
                      className="selectableButton"
                      variant="contained"
                      endIcon={item.status && <Check />}
                      sx={{
                        width: "35%", // or your required width
                        backgroundColor: "white", // no background
                        color: "black", // or any preferred text color
                        fontFamily: "niavhFont",
                        borderRadius: "50px",
                        letterSpacing: "1px",
                        textTransform: "lowercase",
                        boxShadow: "none", // remove button shadow
                        "&:hover": {
                          backgroundColor: "white", // no bg on hover
                          color: "black", // retain same text color
                          boxShadow: "none",
                        },
                        "&:active": {
                          backgroundColor: "white", // no bg on click
                          boxShadow: "none",
                        },
                        "&:focus": {
                          backgroundColor: "white", // no focus bg
                          boxShadow: "none",
                        },
                      }}
                      onClick={() => handleButton(item.id, item.name)}
                    >
                      {item.name}
                    </Button>
                  );
                })}
            </div>
            <div className="submitButtonContainer">
              <Button
                className="selectableButton"
                variant="contained"
                startIcon={<KeyboardBackspaceIcon />}
                // backgroundColor: "#B2435E",
                sx={{
                  width: "31%", // or your required width
                  backgroundColor: "#B2435E", // no background
                  color: "black", // or any preferred text color
                  fontFamily: "niavhFont",
                  borderRadius: "50px",
                  letterSpacing: "1px",
                  textTransform: "lowercase",
                  boxShadow: "none", // remove button shadow
                  "&:hover": {
                    backgroundColor: "#B2435E", // no bg on hover
                    color: "black", // retain same text color
                    boxShadow: "none",
                  },
                }}
                onClick={() => next !== 0 && setnext((prev) => prev - 1)}
              >
                back
              </Button>
              <Button
                className="selectableButton"
                variant="contained"
                endIcon={<ArrowRightAltIcon />}
                sx={{
                  width: "33%", // or your required width
                  backgroundColor: "#B2435E", // no background
                  color: "black", // or any preferred text color
                  fontFamily: "niavhFont",
                  borderRadius: "50px",
                  letterSpacing: "1px",
                  textTransform: "lowercase",
                  boxShadow: "none", // remove button shadow
                  "&:hover": {
                    backgroundColor: "#B2435E", // no bg on hover
                    color: "black", // retain same text color
                    boxShadow: "none",
                  },
                  "&:active": {
                    backgroundColor: "#B2435E", // no bg on click
                    boxShadow: "none",
                  },
                  "&:focus": {
                    backgroundColor: "#B2435E", // no focus bg
                    boxShadow: "none",
                  },
                }}
                onClick={
                  next === 0
                    ? hadleTodayLookData
                    : next === 1
                    ? hadleContrastLookData
                    : hadleMakeUpItems
                }
              >
                {next > 1 ? "submit" : "next"}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* <Collections></Collections> */}
      {/*<SkinToneDectector></SkinToneDectector>*/}
      {/* <Header></Header> */}

      <div className="heading">
        <div>
          <span ref={yoyoSpan1}></span>
          <h1>Luxury makeup for a glam look</h1>
        </div>
        <p>
          Flawless finish with a touch of luxury and elegance, enhancing beauty
          with radiant glow.
        </p>
      </div>
      <SwiperCard></SwiperCard>

      <div className="heading2">
        <div>
          <span ref={yoyoSpan2}></span>
          <h1>Stay close and in touch</h1>
        </div>
        <p>
          Call and text with uninterrupted clarity using Ai Pin’s built-in
          personic speaker or Bluetooth audio.
        </p>
      </div>
      <div className="changeAbleImageContainer">
        <div className="changeAbleImage">
          <img src={imagesArr[activeIndex].image} alt="bgimage" />
        </div>
        <div className="contentContainer">
          <div className="buttonContainer">
            <div
              className="slider"
              style={{ left: `${activeIndex * 25}%` }}
            ></div>

            {["image 1", "image 2", "image 3", "image 4"].map(
              (label, index) => (
                <button
                  key={index}
                  className={activeIndex === index ? "active" : ""}
                  onClick={() => setActiveIndex(index)}
                >
                  {label}
                </button>
              )
            )}
          </div>
          <div className="data">
            <div className="left">
              <p>
                <CgQuote className="dataIcon1" />
                Ask Cami if we're meeting at our usual spot and tell her that
                we'll be heading over there soon.
              </p>
              <p>
                <BsSoundwave className="soundwave-icon dataIcon2" /> {""}
                Your message to Cami says "Hey Cami, are we meeting at our usual
                spot? We’ll be heading there..."
              </p>
            </div>
            <div className="right">
              <div className="messageBox">
                <TbMessageCircleFilled className="messageIcon" />
                <p>Unlimited data, calling & texting</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mutlipleFrames">
        <div className="mutlipleFramesContainer">
          <video loop muted autoPlay className="video1">
            <source src={video1} type="video/mp4" />
          </video>
          <video loop muted autoPlay className="video2">
            <source src={video2} type="video/mp4" />
          </video>

          <video loop muted autoPlay className="video3">
            <source src={video3} type="video/mp4" />
          </video>

          <video loop muted autoPlay className="video4">
            <source src={{ video4 }} type="video/mp4" />
          </video>
          <div className="videoImage1">
            <img src={videoImage2} alt="videoImage1" />
          </div>
          <div className="videoImage2">
            <img src={videoImage3} alt="videoImage2" />
          </div>
          <div className="videoImage3">
            <img src={videoImage1} alt="videoImage3" />
          </div>
          <div className="videoImage4">
            <img src={videoImage2} alt="videoImage1" />
          </div>
        </div>
      </div>

      <div className="heading2">
        <div>
          <span ref={yoyoSpan3}></span>
          <h1>cosmetic products</h1>
        </div>
        <p>Call and text with uninterrupted clarity using Ai</p>
      </div>
      <div className="cosmeticProducts">
        <img
          src={cosmetic_eyeliner}
          className="cosmeticProduct1"
          alt="cosmetic_eyeliner"
        />
        <img
          src={cosmetic_lipstick}
          className="cosmeticProduct2"
          alt="cosmetic_eyeliner"
        />
        <img
          src={cosmetic_brush}
          className="cosmeticProduct2"
          alt="cosmetic_brush"
        />
        <img
          src={cosmetic_hair}
          className="cosmeticProduct4"
          alt="cosmetic_hair"
        />
      </div>
    </>
  );
};

export default Home;
